// extracted by mini-css-extract-plugin
module.exports = {"bg_patern1":"styles_bg_patern1__2puyE","bg_patern2":"styles_bg_patern2__29W-O","bg_patern3":"styles_bg_patern3__qo751","countUp":"styles_countUp__1ioFV"};